import React from 'react';
import { useNavigate } from 'react-router-dom';

const SESSION1_PATH = '/teacher-training/digital/NamdaemoonMiddleSchoolDebethTraining2026';
const TRAINING_PDF_URL = '/training/namdaemoon-debeth-2026-session2.pdf';
const SEN_SCHOOL_URL = 'https://senedu.kr';
const SUPPLEMENTARY_TEXTBOOK_URL =
  'https://drive.google.com/file/d/1U9Nilip3w87d8uBNILK-L8SK9g-4WP1Z/view?usp=sharing';

const ZEP_URL = 'https://zep.us';
const ZEP_QUIZ_URL = 'https://quiz.zep.us';
const QUIZN_URL = 'https://quizn.show/';
const GOOGLE_VIDS_URL = 'https://workspace.google.com/products/vids/';
const NOTEBOOKLM_URL = 'https://notebooklm.google/';
const GEMINI_URL = 'https://gemini.google.com/';

export const trainingMetadataNamdaemoonDebeth2026Session2 = {
  id: 'namdaemoon-middle-debeth-2026-session2',
  title: '남대문중학교 디벗 연수 2회차',
  date: '2026-06-19',
  path: '/teacher-training/digital/NamdaemoonMiddleSchoolDebethTraining2026Session2',
};

const infoBoxStyle: React.CSSProperties = {
  backgroundColor: 'var(--Color-background-normal)',
  border: '1px solid var(--Color-line-normal)',
  borderRadius: '12px',
  padding: '16px',
  marginBottom: '16px',
};

const NamdaemoonMiddleSchoolDebethTraining2026Session2: React.FC = () => {
  const navigate = useNavigate();

  const linkButton = (href: string, label: string, external = true) => (
    <a
      href={href}
      {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      style={{
        display: 'inline-block',
        marginTop: '8px',
        padding: '10px 18px',
        backgroundColor: 'var(--Color-fill-brand-color)',
        color: 'var(--Color-text-inverse)',
        textDecoration: 'none',
        borderRadius: '8px',
        fontWeight: 600,
        fontSize: '14px',
        fontFamily: 'var(--font-family-primary)',
      }}
    >
      {label} →
    </a>
  );

  const tableStyle: React.CSSProperties = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
    marginTop: '12px',
  };

  const thStyle: React.CSSProperties = {
    border: '1px solid var(--Color-line-normal)',
    padding: '10px 12px',
    backgroundColor: 'var(--Color-background-main)',
    textAlign: 'left',
    fontWeight: 600,
    color: 'var(--Color-text-strong)',
  };

  const tdStyle: React.CSSProperties = {
    border: '1px solid var(--Color-line-normal)',
    padding: '10px 12px',
    color: 'var(--Color-text-normal)',
    lineHeight: 1.6,
    verticalAlign: 'top',
  };

  const toc = [
    ['#연수-개요', '연수 개요'],
    ['#연수-흐름', '1회차 → 2회차 흐름'],
    ['#순서-1', '1. ZEP School'],
    ['#순서-2', '2. ZEP Quiz'],
    ['#순서-3', '3. QuizN'],
    ['#순서-4', '4. Google Vids'],
    ['#순서-5', '5. AI 연결 (Gemini · NotebookLM)'],
    ['#순서-6', '6. 마무리 · 수업 설계'],
    ['#연수-자료', '연수 발표 자료 (PDF)'],
    ['#연수-보조-자료', '연수 보조 자료'],
  ];

  return (
    <div
      style={{
        width: '100%',
        minHeight: '100%',
        boxSizing: 'border-box',
        padding: '24px',
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        fontFamily: 'var(--font-family-primary)',
        backgroundColor: 'var(--Color-background-main)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' }}>
        <button
          type="button"
          onClick={() => navigate('/teacher-training/training-pages')}
          style={{
            padding: '8px 16px',
            backgroundColor: 'var(--Color-fill-normal)',
            color: 'var(--Color-text-inverse)',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          ← 돌아가기
        </button>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700, margin: 0, color: 'var(--Color-text-strong)', lineHeight: 1.4 }}>
          {trainingMetadataNamdaemoonDebeth2026Session2.title}
        </h1>
      </div>

      <div style={{ marginBottom: '24px' }}>{linkButton(SEN_SCHOOL_URL, 'SEN 스쿨(senedu.kr) 바로가기')}</div>

      <div
        style={{
          marginBottom: '24px',
          border: '1px solid var(--Color-line-normal)',
          padding: '16px',
          borderRadius: '12px',
          backgroundColor: 'var(--Color-background-normal)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}
      >
        <h2 style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.125rem', color: 'var(--Color-text-strong)' }}>목차</h2>
        <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
          {toc.map(([hash, label]) => (
            <li key={hash} style={{ marginBottom: '8px' }}>
              <a href={hash} style={{ textDecoration: 'none', color: 'var(--Color-fill-brand-color)', fontWeight: 500, fontSize: '15px' }}>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <h2 id="연수-개요" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        연수 개요
      </h2>
      <div style={{ ...infoBoxStyle, marginBottom: '20px' }}>
        <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          주제: 디벗 활용 2단계 — 참여형 수업에 AI 더하기
        </p>
        <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          일시: 2026년 6월 19일
        </p>
        <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          대상: 남대문중학교 교직원
        </p>
        <p style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          강사: 한지호
        </p>
      </div>
      <p style={{ color: 'var(--Color-text-normal)', marginBottom: '16px', lineHeight: 1.7, fontSize: '15px' }}>
        ZEP School · ZEP Quiz · QuizN · Google Vids · Gemini · NotebookLM으로 연결하는 수업 콘텐츠 제작 연수입니다.
        지난 연수의 &ldquo;디벗 활용&rdquo;을 넘어, 참여·제작·AI 기반 수업으로 확장합니다.
      </p>
      <div style={{ ...infoBoxStyle, marginBottom: '28px', backgroundColor: '#fff8f0', borderColor: 'var(--Color-fill-brand-color)' }}>
        <p style={{ margin: 0, fontSize: '15px', color: 'var(--Color-text-strong)', fontWeight: 600, lineHeight: 1.7 }}>
          핵심 질문: &ldquo;디벗으로 무엇을 할까?&rdquo;에서 &ldquo;학생이 어떻게 참여하고, 만들고, AI로 개선하게 할까?&rdquo;로
        </p>
      </div>

      <h2 id="연수-흐름" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        1회차 → 2회차 흐름
      </h2>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={thStyle}>구분</th>
            <th style={thStyle}>내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}><strong>지난 연수</strong></td>
            <td style={tdStyle}>PDF·삼성노트·디벗 기본 활용</td>
          </tr>
          <tr>
            <td style={tdStyle}><strong>이번 1단계</strong></td>
            <td style={tdStyle}>ZEP 공간과 게임형 퀴즈</td>
          </tr>
          <tr>
            <td style={tdStyle}><strong>이번 2단계</strong></td>
            <td style={tdStyle}>Google Vids로 영상 제작</td>
          </tr>
          <tr>
            <td style={tdStyle}><strong>이번 3단계</strong></td>
            <td style={tdStyle}>Gemini · NotebookLM으로 AI 연결</td>
          </tr>
        </tbody>
      </table>
      <p style={{ marginBottom: '32px', fontSize: '14px' }}>
        {linkButton(SESSION1_PATH, '1회차 연수 자료 보기', false)}
      </p>

      <h2 id="순서-1" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        1. ZEP School
      </h2>
      <p style={{ color: 'var(--Color-text-normal)', marginBottom: '12px', lineHeight: 1.7, fontSize: '15px' }}>
        공간 자체보다 &ldquo;학습 경험&rdquo;을 설계합니다. 학생이 같은 공간에서 탐색하고, 상호작용하고, 결과물을 공유하게 합니다.
      </p>
      <ol style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px', paddingLeft: '22px' }}>
        <li><strong>탐색</strong> — 교과 자료·전시물·NPC를 찾아다니며 정보 확인</li>
        <li><strong>미션</strong> — 공간 속 단서를 해결하고 다음 활동으로 이동</li>
        <li><strong>공유</strong> — 모둠 결과물과 프로젝트 산출물을 전시하고 상호 피드백</li>
      </ol>
      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>추천 실습: &ldquo;우리 교과 결과물 전시 공간&rdquo; 3구역 기획</h3>
        <ul style={{ margin: 0, paddingLeft: '20px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
          <li>입구: 학습 목표와 이동 안내</li>
          <li>중앙: 자료 탐색·미션 수행</li>
          <li>마지막: 학생 결과물 전시·댓글 또는 발표</li>
        </ul>
        <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          예: 과학 탐구 전시관, 사회 지역 박람회, 기술 프로젝트 게임쇼, 진로 직업 체험관
        </p>
      </div>
      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>ZEP School 수업 설계 체크</h3>
        <table style={tableStyle}>
          <tbody>
            {[
              ['목적', '전시·탐색·협업·체험 중 무엇인가?'],
              ['동선', '입장 후 어디로 이동하고 무엇을 확인하는가?'],
              ['상호작용', 'NPC·오브젝트·퀴즈·댓글 중 무엇을 쓰는가?'],
              ['결과물', '학생은 무엇을 만들고 어디에 게시하는가?'],
              ['평가', '관찰·미션 기록·성찰을 어떻게 남기는가?'],
              ['운영', '입장 코드·활동 시간·동시 접속을 어떻게 관리하는가?'],
            ].map(([k, v]) => (
              <tr key={k}>
                <td style={tdStyle}><strong>{k}</strong></td>
                <td style={tdStyle}>{v}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          공간은 배경이고, 수업 목표와 학생 활동이 본체입니다.
        </p>
        {linkButton(ZEP_URL, 'ZEP School 바로가기')}
      </div>

      <h2 id="순서-2" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        2. ZEP Quiz
      </h2>
      <p style={{ color: 'var(--Color-text-normal)', marginBottom: '12px', lineHeight: 1.7, fontSize: '15px' }}>
        참여를 끌어내는 게임형 퀴즈입니다. QR·링크로 바로 참여하고, AI로 문항 초안을 빠르게 만들 수 있습니다.
      </p>
      <ul style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
        <li><strong>빠른 입장</strong> — 앱 설치 없이 브라우저에서 QR 또는 링크로 참여</li>
        <li><strong>게임 맵</strong> — 아바타 이동과 맵 요소로 복습 활동을 게임처럼 구성</li>
        <li><strong>AI 문항 생성</strong> — 주제 또는 자료를 바탕으로 문제·선택지 초안 생성</li>
      </ul>
      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>수업 활용 장면</h3>
        <p style={{ margin: 0, lineHeight: 1.7, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
          도입(사전지식 확인) · 중간(개념 이해 점검) · 마무리(단원 복습·오개념 확인) · 학생 제작(모둠별 문제 출제)
        </p>
        <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          AI가 할 일 → 문항 초안·선택지·해설 생성 / 교사가 할 일 → 교육과정 적합성·난이도·정답 검토
        </p>
      </div>
      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>ZEP Quiz 실습 (5문항)</h3>
        <ol style={{ margin: '0 0 12px 0', paddingLeft: '20px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
          <li>교과·단원 선택</li>
          <li>학습목표 입력</li>
          <li>AI 문항 초안 생성</li>
          <li>교사가 수정·검토</li>
          <li>맵 선택·공유</li>
          <li>결과 확인</li>
        </ol>
        <p style={{ margin: 0, fontSize: '14px', color: 'var(--Color-text-normal)', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
          {`실습용 프롬프트 예시:\n중학교 1학년 기술 수업에서 사용할 4지선다 퀴즈 5문항을 만들어줘.\n단원: 기술의 발달과 사회 변화\n학습목표: 기술 발달이 생활과 직업에 미친 영향을 설명할 수 있다.\n조건: 암기형 2문항 이하, 실제 사례 적용 문항 포함, 정답과 해설 제공.`}
        </p>
        {linkButton(ZEP_QUIZ_URL, 'ZEP Quiz 바로가기')}
      </div>

      <h2 id="순서-3" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        3. QuizN
      </h2>
      <p style={{ color: 'var(--Color-text-normal)', marginBottom: '12px', lineHeight: 1.7, fontSize: '15px' }}>
        퀴즈를 넘어 실시간 상호작용입니다. PIN 또는 링크로 참여하고, 퀴즈쇼·보드·게임러닝 형태로 수업 반응을 모읍니다.
      </p>
      <ul style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
        <li><strong>실시간 퀴즈쇼</strong> — 교사 진행에 맞춰 문제를 풀고 순위·정답 반응을 즉시 확인</li>
        <li><strong>보드·CLASS</strong> — 의견, 아이디어, 카드형 콘텐츠를 모아 수업 중 사고를 공유</li>
        <li><strong>AI 문제 생성</strong> — AI로 퀴즈 생성·추천 기능을 활용해 제작 시간 단축</li>
      </ul>
      <div style={{ ...infoBoxStyle, marginBottom: '16px' }}>
        <p style={{ margin: 0, fontSize: '15px', color: 'var(--Color-text-normal)', lineHeight: 1.7 }}>
          <strong>퀴즈만 필요한가?</strong> → ZEP Quiz &nbsp;|&nbsp; <strong>퀴즈 + 보드 + 반응 수집이 필요한가?</strong> → QuizN
        </p>
      </div>
      <table style={{ ...tableStyle, marginBottom: '32px' }}>
        <thead>
          <tr>
            <th style={thStyle}>비교</th>
            <th style={thStyle}>ZEP Quiz</th>
            <th style={thStyle}>QuizN</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}><strong>핵심 경험</strong></td>
            <td style={tdStyle}>아바타·맵 기반 게임형 퀴즈</td>
            <td style={tdStyle}>실시간 퀴즈쇼·보드·반응 수집</td>
          </tr>
          <tr>
            <td style={tdStyle}><strong>추천 장면</strong></td>
            <td style={tdStyle}>단원 복습·미션형 형성평가</td>
            <td style={tdStyle}>연수·토론·의견 수합·골든벨</td>
          </tr>
          <tr>
            <td style={tdStyle}><strong>선택 기준</strong></td>
            <td style={tdStyle}>게임 몰입과 이동이 중요할 때</td>
            <td style={tdStyle}>한 화면에서 다양한 반응을 모을 때</td>
          </tr>
        </tbody>
      </table>
      <div style={{ marginBottom: '32px' }}>{linkButton(QUIZN_URL, 'QuizN 바로가기')}</div>

      <h2 id="순서-4" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        4. Google Vids
      </h2>
      <p style={{ color: 'var(--Color-text-normal)', marginBottom: '12px', lineHeight: 1.7, fontSize: '15px' }}>
        학교 콘텐츠를 짧은 영상으로 만듭니다. 브라우저에서 장면 구성·편집·협업·공유를 한 흐름으로 진행합니다.
      </p>
      <ul style={{ marginBottom: '16px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
        <li>수업 콘텐츠 — 개념 설명, 실험 절차, 프로젝트 안내 영상</li>
        <li>학생 결과물 — 책 소개, 탐구 발표, 캠페인, 포트폴리오 영상</li>
        <li>학교 안내 — 행사, 안전교육, 수행평가, 학부모 안내 영상화</li>
      </ul>
      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>실습: 60초 안내 영상 (디지털 시민성)</h3>
        <ol style={{ margin: 0, paddingLeft: '20px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
          <li>문제 제시 — 학생들이 왜 주의해야 하나?</li>
          <li>핵심 규칙 1 — 사진·영상은 동의 후 촬영</li>
          <li>핵심 규칙 2 — 온라인에서도 존중하는 표현</li>
          <li>문제 상황 — 불편한 일이 생기면 즉시 알리기</li>
          <li>마무리 — 우리 모두가 안전한 디지털 교실 만들기</li>
        </ol>
        <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: 'var(--Color-text-normal)' }}>
          AI 활용: 영상 제작을 대신시키기보다 &ldquo;장면 순서·자막·내레이션 초안&rdquo;을 설계하게 합니다.
        </p>
        {linkButton(GOOGLE_VIDS_URL, 'Google Vids 바로가기')}
      </div>

      <h2 id="순서-5" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        5. AI 연결 (Gemini · NotebookLM)
      </h2>
      <p style={{ color: 'var(--Color-text-normal)', marginBottom: '16px', lineHeight: 1.7, fontSize: '15px' }}>
        AI는 답변 도구에서 &ldquo;제작 환경&rdquo;으로 확장됩니다. AI는 초안을 만들고, 교사는 목표·정확성·난이도를 설계하고 검토합니다.
      </p>
      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>좋은 프롬프트 6가지</h3>
        <table style={tableStyle}>
          <tbody>
            {[
              ['대상', '학년·수준'],
              ['학습목표', '수업 후 할 수 있어야 하는 것'],
              ['활용 도구', 'ZEP Quiz · QuizN · Vids 등'],
              ['결과물', '문항 · 대본 · 미션 · 질문'],
              ['조건', '난이도 · 개수 · 시간'],
              ['검토 기준', '정답 · 출처 · 편향 · 연령 적합성'],
            ].map(([k, v]) => (
              <tr key={k}>
                <td style={tdStyle}><strong>{k}</strong></td>
                <td style={tdStyle}>{v}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>NotebookLM</h3>
        <p style={{ margin: '0 0 12px 0', color: 'var(--Color-text-normal)', lineHeight: 1.7, fontSize: '15px' }}>
          &ldquo;내가 넣은 자료&rdquo;를 기반으로 요약·질문·콘텐츠 변환합니다. 교과 PDF·수업자료·공문을 근거로 활용하세요.
        </p>
        <p style={{ margin: 0, fontSize: '14px', color: 'var(--Color-text-normal)', lineHeight: 1.6 }}>
          연계 흐름: 수업자료 → NotebookLM(핵심 개념) → Gemini(문항·대본) → ZEP Quiz·QuizN·Vids(학생 참여)
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '12px' }}>
          {linkButton(NOTEBOOKLM_URL, 'NotebookLM')}
          {linkButton(GEMINI_URL, 'Gemini')}
        </div>
      </div>
      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>하나의 수업으로 연결</h3>
        <p style={{ margin: 0, fontSize: '15px', color: 'var(--Color-text-normal)', lineHeight: 1.7 }}>
          자료 분석(NotebookLM) → 콘텐츠 생성(Gemini) → 학생 참여(ZEP Quiz·QuizN) → 영상 제작(Google Vids) → 공간 공유(ZEP School).
          도구를 많이 쓰는 수업이 아니라, 학습 목표에 필요한 도구만 연결하는 수업입니다.
        </p>
      </div>

      <h2 id="순서-6" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        6. 마무리 · 수업 설계
      </h2>
      <div style={infoBoxStyle}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>내 수업 1차시 설계</h3>
        <ol style={{ margin: 0, paddingLeft: '20px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
          <li>수업 목표 — 학생이 무엇을 할 수 있어야 하나?</li>
          <li>참여 방식 — 탐색·퀴즈·토론·제작 중 무엇인가?</li>
          <li>도구 선택 — ZEP School · ZEP Quiz · QuizN · Vids 중 무엇이 필요한가?</li>
          <li>AI 역할 — 문항·대본·미션·피드백 중 무엇을 도울까?</li>
          <li>학생 결과물 — 무엇을 만들고 어디에 공유할까?</li>
          <li>검토 기준 — 정확성·난이도·개인정보를 어떻게 확인할까?</li>
        </ol>
        <p style={{ margin: '12px 0 0 0', fontSize: '14px', color: 'var(--Color-text-normal)', lineHeight: 1.6 }}>
          예: NotebookLM으로 교과자료를 요약하고 → Gemini로 5문항을 만들고 → QuizN으로 형성평가 → Vids로 학생 설명 영상 제작
        </p>
      </div>
      <div style={{ ...infoBoxStyle, marginBottom: '32px' }}>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: 'var(--Color-text-strong)' }}>수업 적용 전 확인</h3>
        <ul style={{ margin: 0, paddingLeft: '20px', lineHeight: 1.8, color: 'var(--Color-text-normal)', fontSize: '15px' }}>
          <li>계정·기능 — 학교 계정에서 사용 가능 여부와 요금제 확인</li>
          <li>개인정보 — 학생 실명·민감정보·얼굴·음성 업로드 최소화</li>
          <li>정확성 — AI 문항의 정답·해설·출처를 교사가 검토</li>
          <li>접근성 — 기기·브라우저·네트워크·학생 수준에서 작동하는가</li>
          <li>대안 — 접속 실패 시 종이·링크·공동 화면 대안 마련</li>
        </ul>
      </div>
      <div style={{ ...infoBoxStyle, marginBottom: '32px', backgroundColor: '#fff8f0', borderColor: 'var(--Color-fill-brand-color)' }}>
        <p style={{ margin: 0, fontSize: '15px', color: 'var(--Color-text-normal)', lineHeight: 1.7 }}>
          <strong>정리:</strong> 공간을 만든다 → ZEP School · 참여를 끌어낸다 → ZEP Quiz · QuizN · 설명하고 공유한다 → Google Vids ·
          자료를 근거로 콘텐츠를 만든다 → Gemini · NotebookLM. 도구의 개수가 아니라, 학생의 참여·창작·피드백 흐름을 설계합니다.
        </p>
      </div>

      <h2 id="연수-자료" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        연수 발표 자료 (PDF)
      </h2>
      <p style={{ color: 'var(--Color-text-normal)', marginBottom: '12px', lineHeight: 1.7, fontSize: '15px' }}>
        {linkButton(TRAINING_PDF_URL, '발표 자료 PDF 다운로드')}
      </p>
      <div
        style={{
          borderRadius: '12px',
          overflow: 'hidden',
          border: '1px solid var(--Color-line-normal)',
          width: '100%',
          height: '720px',
          backgroundColor: 'var(--Color-background-normal)',
          marginBottom: '24px',
        }}
      >
        <iframe
          title="연수 발표 자료 PDF"
          src={TRAINING_PDF_URL}
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      </div>

      <h2 id="연수-보조-자료" style={{ fontWeight: 700, marginBottom: '12px', fontSize: '1.35rem', color: 'var(--Color-text-strong)' }}>
        연수 보조 자료
      </h2>
      <div style={{ ...infoBoxStyle, marginBottom: '24px' }}>
        <p style={{ margin: '0 0 8px 0', fontSize: '15px', fontWeight: 600, color: 'var(--Color-text-strong)' }}>
          [미래엔] 중학교 진로와 직업 교과서 1단원
        </p>
        <p style={{ margin: '0 0 12px 0', color: 'var(--Color-text-normal)', lineHeight: 1.7, fontSize: '15px' }}>
          NotebookLM·Gemini 실습 시 참고할 교과 PDF입니다. Google Drive에서 열거나 다운로드할 수 있습니다.
        </p>
        {linkButton(SUPPLEMENTARY_TEXTBOOK_URL, '교과서 PDF 보기 (Google Drive)')}
      </div>
    </div>
  );
};

export default NamdaemoonMiddleSchoolDebethTraining2026Session2;
